const WASM_URL = "/catalog/agility-rt.wasm";
const GLUE_URL = "/catalog/agility-rt.js";
export async function compileEngine() {
    try {
        const resp = await fetch(WASM_URL);
        if (!resp.ok)
            return null;
        const ctype = resp.headers.get("content-type") ?? "";
        if (!ctype.includes("wasm") && !ctype.includes("octet-stream")) {
            console.info(`[wasm-loader] ${WASM_URL} did not return a wasm ` +
                `content-type (got '${ctype || "none"}'); using JS fallback`);
            return null;
        }
        const bytes = await resp.arrayBuffer();
        const module = await WebAssembly.compile(bytes);
        console.info(`[wasm-loader] compiled ${WASM_URL} ` + `(content-type=${ctype})`);
        let factory;
        let glueUrl;
        try {
            const resolved = new URL(GLUE_URL, location.origin).href;
            console.info(`[wasm-loader] importing emscripten glue (main thread) ` +
                `from ${resolved}`);
            const glue = await import(/* @vite-ignore */ resolved);
            if (typeof glue.default === "function") {
                factory = glue.default;
                glueUrl = resolved;
                console.info("[wasm-loader] glue import ok on main thread; " +
                    "worklet will re-import from " +
                    glueUrl);
            }
            else {
                console.info("[wasm-loader] glue module loaded but has no default " +
                    "factory export; WASM cannot self-instantiate in the " +
                    "worklet — JS DSP fallback will be used.");
            }
        }
        catch (err) {
            console.info("[wasm-loader] failed to import emscripten glue " +
                `(${GLUE_URL}); JS DSP fallback will be used.`, err);
            factory = undefined;
        }
        const wasmUrl = new URL(WASM_URL, location.origin).href;
        return { module, bytes, factory, glueUrl, wasmUrl };
    }
    catch (err) {
        console.info("[wasm-loader] engine compile/fetch failed; using JS DSP fallback", err);
        return null;
    }
}
